import React, { useEffect, useId, useState } from "react";
import Select, { components } from "react-select";
import accessibility from "../../accessibility";
import tampuuriWindowObject from "../../tampuuriWindowObject";

const SelectLocation = (props) => {
  const { title, placeholder, params, submitParams, svgObjects } = props;
  const [options, setOptions] = useState([]);
  const [state, setState] = useState({});
  const { translate, getCityAreaAddress } = tampuuriWindowObject();
  const [inputValue, setInputValue] = useState("");
  const { announceMessage, globalAccessibilitySpeakerId } = accessibility();
  const selectId = useId();
  const selectedElementsId = useId();

  useEffect(() => {
    setState({ loading: true });
    Promise.resolve(getCityAreaAddress())
      .then((res) => {
        setOptions(res);
        setState({ loading: false });
      })
      .catch((e) => {
        setState({ error: true });
      });
  }, []);

  const customStyles = {
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        fontSize: "14px",
        fontWeight: "450",
        lineHeight: "21px",
        letterSpacing: "0px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverFlow: "ellipsis",
        color: "#5f6f75",
      };
    },
    control: (provided) => {
      let styles = {
        textAlign: "start",
        fontFamily: "Circular-Book,Helvetica,Arial,sans-serif",
        fontStyle: "normal",
        fontWeight: "450",
        fontSize: "20px",
        lineHeight: "25px",
        color: "#000000",
        height: "44px",
        border: "1px solid #979797",
        width: "100%",
      };

      return { ...provided, ...styles };
    },
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (provided) => {
      return { ...provided, color: "#000000" };
    },
    multiValue: (provided) => {
      return {
        display: "none",
      };
    },
    menu: (provided) => {
      return {
        ...provided,
        marginTop: "0px",
      };
    },
    menuList: (provided) => {
      return {
        ...provided,
        paddingBottom: "0px",
        paddingTop: "0px",
      };
    },
    input: (provided) => {
      return {
        ...provided,
      };
    },
    valueContainer: (provided) => {
      return {
        ...provided,
        padding: "2px 0px",
      };
    },
    container: (base) => ({
      ...base,
      width: "100%",
    }),
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          width="16"
          height="16"
        >
          <path d="M433 209L241 393c-5 5-11 7-17 7s-12-2-17-7L15 209c-9-9-10-24 0-34 9-9 24-9 34 0l175 168 175-168c10-9 25-9 34 0 10 10 9 25 0 34z"></path>
        </svg>
      </components.DropdownIndicator>
    );
  };

  const ControlIndicator = ({ children, ...props }) => {
    return (
      <components.Control {...props}>
        <div dangerouslySetInnerHTML={{ __html: svgObjects?.search }} />
        {children}
      </components.Control>
    );
  };

  const handleLocations = (values) => {
    let newLocations = values.map((v) => v.value);
    submitParams({ locations: [...params.locations, ...newLocations] });
  };

  const returnOptions = () => {
    let final = [];

    options.forEach((row) => {
      if (!params.locations.includes(row.value)) {
        final.push(row);
      }
    });

    return final;
  };

  const removeSelectedLocations = () => {
    const callback = () => {
      setTimeout(() => {
        document.getElementById(selectId).focus();
      }, 200);
    };

    announceMessage(globalAccessibilitySpeakerId, "Removed all", callback);
    submitParams({ locations: [] });
  };

  const removeLocation = (value) => {
    let newLocations = [];

    params?.locations?.forEach((s) => {
      if (s !== value) {
        newLocations.push(s);
      }
    });

    submitParams({ locations: newLocations });

    const callback = () => {
      setTimeout(() => {
        document.getElementById(selectId).focus();
      }, 200);
    };
    announceMessage(globalAccessibilitySpeakerId, "Removed " + value, callback);
  };

  return (
    <div className="main-multiselect">
      <div className="select-container">
        <label htmlFor={selectId}>{title}</label>
        <Select
          inputId={selectId}
          aria-label={placeholder}
          components={{
            DropdownIndicator: DropdownIndicator,
            Control: ControlIndicator,
          }}
          menuPosition="top"
          className="select-city-area-address"
          classNamePrefix="select"
          isDisabled={false}
          onChange={handleLocations}
          isLoading={state?.loading}
          isClearable={false}
          isRtl={false}
          isSearchable={true}
          name="city-area-address"
          options={returnOptions()}
          value={[]}
          styles={customStyles}
          isMulti={true}
          placeholder={inputValue ? inputValue : placeholder}
          noOptionsMessage={() => translate("Ei vaihtoehtoja saatavilla")}
        />
      </div>
      {params.locations?.length > 0 && (
        <div
          className="selected-options-container"
          role="group"
          aria-labelledby={selectedElementsId}
        >
          <span className="sr-only" id={selectedElementsId}>
            {" "}
            {translate("Selected filters")},{translate("count")}:{" "}
            {params.locations.length}
          </span>

          {params.locations.map((value) => {
            return (
              <button
                key={value}
                className="selected-option"
                aria-label={`${translate("Poista valinta")} ${value}`}
                onClick={(e) => {
                  removeLocation(value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    removeLocation(value);
                  }
                }}
              >
                {value}
                <div
                  className="center ml-4"
                  dangerouslySetInnerHTML={{
                    __html: svgObjects?.close,
                  }}
                />
              </button>
            );
          })}

          <button
            aria-label={translate("Poista valinnat")}
            onClick={removeSelectedLocations}
            onKeyDown={(e) => {
              if (e.key === "enter") {
                e.preventDefault();
                removeSelectedLocations();
              }
            }}
            className="remove-options"
          >
            <span className="mr-2">{translate("Poista valinnat")}</span>
            <div
              className="center"
              dangerouslySetInnerHTML={{
                __html: svgObjects?.close,
              }}
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default SelectLocation;
